// tslint:disable
/* MACLE TypeScript 21/03/2025 12:32:16 */
import { BaseData } from './maf.vo';
import { ArrayList } from 'maf-web';

export class FilterPagarMeTransacao extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.FilterPagarMeTransacao";
}


export class PKVitrine extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.PKVitrine";
  codVitrine: number = 0;

  constructor()
  constructor(codVitrine: number)
  constructor(codVitrine?: number) {
    super();
    this.codVitrine = codVitrine || 0;
  }

  public getPK(): PKVitrine {
    return new PKVitrine(this.codVitrine);
  }

  public equals(arg: PKVitrine): boolean {
    return arg 
        && (arg.codVitrine === this.codVitrine)
    ;
  }
}


export class DataVitrine extends PKVitrine {
  readonly jclass: string = "com.liquidacaoParcela.vo.DataVitrine";
  logoBase64: string = "";
  descricao: string = "";
  urlVitrine: string = "";
}


export class FilterVenda extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.FilterVenda";
}


export class ConsVitrineAndItem extends BaseData {
  readonly jclass: string = "com.liquidacaoParcela.vo.ConsVitrineAndItem";
  vitrine: DataVitrine = new DataVitrine();
  listItens: string[] = [];
}


